module.exports = __webpack_public_path__ + "static/img/login_logo.07fec34.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_logo.gif
// module id = kuh2
// module chunks = 3